export default "__VITE_ASSET__bNXQbkh$__"